export enum BankAccountTypeEnum  {
  SAVINGS_ACCOUNT = 'cp',
  CHECKING_ACCOUNT = 'cc',
  CASH_ACCOUNT = 'ca',
  INVESTMENT_ACCOUNT = 'ic',
}